module.exports = __webpack_public_path__ + "img/第5章_3-3_警察署九宮格_警察署.jpg";